export type FeatureAppConfig = {
  readonly id: string;
  readonly featureAppName: string;
  readonly versionHash: string;
  readonly src: string;
  readonly baseUrl: string;
  readonly config?: {productId: string};
};

export enum Sorting {
  Relevance = `relevance`,
  NameAsc = `name-asc`,
  NameDesc = `name-desc`,
  PriceAsc = `price-asc`,
  PriceDesc = `price-desc`,
}

export type Banner = {
  readonly type: 'banner';
  readonly template: 'campaign' | 'offer';
  readonly backgroundColorOption?:
    | 'premium #1'
    | 'premium #3'
    | 'brabus'
    | 'pulse'
    | 'pro+'
    | 'pro,pure+,pure';
  readonly title: string;
  readonly position: number;
  readonly imageUrl: string;
  readonly description: string;
  readonly leasingCycleLabel: string;
  readonly price: string;
  readonly linkLabel: string;
  readonly linkDestination?: any;
  readonly fromLabel: string;
};

export type ProductSearchApiResponse = {
  'response-data': ProductSearchApiResponseData;
};

export type ProductSearchApiResponseData = {
  currentQuery: SearchState;
  facets: Facet[];
  products?: Product[];
};

export type Facet = {
  code: string;
  name: string;
  values: FacetValue[];
  visible: boolean;
  priority: number;
};

export type FacetValue = {
  count: number;
  description: string;
  displayName: string;
  name: string;
  query: SearchState;
  selected: boolean;
  url: string;
  priority?: number;
};

export type SearchState = {
  query: SearchQuery;
  url: string;
};

export type SearchQuery = {
  value: string;
};

export type Product = {
  batteryName: string;
  brand: string;
  code: string;
  exteriorCode: string;
  exteriorName: string;
  interiorCode: string;
  interiorName: string;
  leasingPrice: Price;
  netLeasingPrice: Price;
  lineCode: string;
  lineName: string;
  modelYear: string;
  name: string;
  price: Price;
  netPrice: Price;
  roofCode: string;
  roofDescription: string;
  stock: Stock;
  classifications: Classification[];
  productType: string;
  badges: Badge[];
};

export type Price = {
  currencyIso: string;
  formattedValue: string;
  value: number;
};

export type Stock = {
  beautifiedLeadTime: string[];
  earliestBeautifiedLeadTime: string;
  isValueRounded: boolean;
  leadTime: number;
  stockLevel: number;
  stockLevelStatus: string;
};

export type Classification = {
  code: string;
  features: Feature[];
};

export type Feature = {
  code: string;
  comparable: boolean;
  featureValues: {value: string}[];
  name: string;
};

export type Badge = {
  code: string;
  name: string;
  priority: number;
  type: BadgeTypes;
};

export type BadgeTypes = 'PRIMARY' | 'GHOST' | 'GRAY' | 'LIME';
